import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  useMediaQuery,
  Badge
} from '@material-ui/core';
import { useRouteMatch, useLocation } from 'react-router-dom';
import Popup from '../../components/Modal/PopUp';
import * as ROUTES from '../../routes/index';
import Session from '../../components/Headers/Session';
import { connect } from 'react-redux';
import { decryptPassword, doSignInWithEmailAndPassword } from '../../configs/environments/firebase/firebaseApp';
import { logoutUser, loginUser, changeToCourtesyLawyer } from '../../store/actions/UserAction';
import { showLoading, hideLoading } from '../../store/actions/LoadingActions';
import SwitcherList from './SwitcherList';
import SwitcherModal from './SwitcherModal';

const homeBlueImg = '/img/icons/home-blue.svg';
const profileBlueImg = '/img/icons/profile-blue.svg';
const analyticsBlueImg = '/img/icons/analytics-blue.svg';
const membershipBlueImg = '/img/icons/membership-blue.svg';
const messagesBlueImg = '/img/icons/messages-blue.svg';
const opinionsBlueImg = '/img/icons/opinions-blue.svg';
const notificationsBlueImg = '/img/icons/notifications-blue.svg';
const accountBlueImg = '/img/icons/account-blue.svg';
const termsConditionsBlueImg = '/img/icons/terms-conditions-blue.svg';
const signOutBlueImg = '/img/icons/sign-out-blue.svg';
const homeWhiteImg = '/img/icons/home-white.svg';
const profileWhiteImg = '/img/icons/profile-white.svg';
const analyticsWhiteImg = '/img/icons/analytics-white.svg';
const membershipWhiteImg = '/img/icons/membership-white.svg';
const messagesWhiteImg = '/img/icons/messages-white.svg';
const opinionsWhiteImg = '/img/icons/opinions-white.svg';
const notificationsWhiteImg = '/img/icons/notifications-white.svg';
const accountWhiteImg = '/img/icons/account-white.svg';
const termsConditionsWhiteImg = '/img/icons/terms-conditions-white.svg';
const signOutWhiteImg = '/img/icons/sign-out-white.svg';
const portfolioBlue = '/img/icons/portafolio-blue.svg';
const trashBlue = '/img/icons/trash-blue.svg';
const usersBlue = '/img/icons/users-blue.svg';
const contactBlue = '/img/icons/contact-center-blue.svg';
const articleBlue = '/img/icons/article-blue.svg';
const portfolioWhite = '/img/icons/portafolio-white.svg';
const trashWhite = '/img/icons/trash-white.svg';
const usersWhite = '/img/icons/users-white.svg';
const contactWhite = '/img/icons/contact-center-white.svg';
const articleWhite = '/img/icons/article-white.svg';
const proposalBlue = '/img/icons/cotizacion-blue.svg';
const proposalWhite = '/img/icons/cotizacion-white.svg';


let lawyerOptions = [
  {
    name: 'Home',
    route: ROUTES.HOME,
    whiteImage: homeWhiteImg,
    blueImage: homeBlueImg,
  },
  {
    name: 'Perfil',
    route: ROUTES.PROFILE,
    whiteImage: profileWhiteImg,
    blueImage: profileBlueImg,
  },
  {
    name: 'Analytics',
    route: ROUTES.ANALYTICS,
    whiteImage: analyticsWhiteImg,
    blueImage: analyticsBlueImg,
  },
  {
    name: 'Membresía',
    route: ROUTES.MEMBERSHIP,
    whiteImage: membershipWhiteImg,
    blueImage: membershipBlueImg,
  }, 
  {
    name: 'Mensajes',
    route: ROUTES.MESSAGES,
    whiteImage: messagesWhiteImg,
    blueImage: messagesBlueImg,
  },
  {
    name: 'Propuesta económica',
    route: ROUTES.ECONOMIC_PROPOSAL,
    whiteImage: proposalWhite,
    blueImage: proposalBlue,
  }, 
  {
    name: 'Opiniones',
    route: ROUTES.OPINIONS,
    whiteImage: opinionsWhiteImg,
    blueImage: opinionsBlueImg,
  },
  {
    name: 'Notificaciones',
    route: ROUTES.NOTIFICATIONS,
    whiteImage: notificationsWhiteImg,
    blueImage: notificationsBlueImg,
  },
  {
    name: 'Cuenta',
    route: ROUTES.ACCOUNT,
    whiteImage: accountWhiteImg,
    blueImage: accountBlueImg,
  },
  { isDivider: true },
  {
    name: 'Términos',
    route: ROUTES.TERMS_CONDITIONS,
    whiteImage: termsConditionsWhiteImg,
    blueImage: termsConditionsBlueImg,
  },
  {
    name: 'Cerrar sesión',
    route: ROUTES.SIGNIN,
    whiteImage: signOutWhiteImg,
    blueImage: signOutBlueImg,
  },
];

const adminOptions = [
  {
    name: 'Analytics',
    route: ROUTES.DASHBOARD_ADMIN,
    whiteImage: analyticsWhiteImg,
    blueImage: analyticsBlueImg,
  },
  {
    name: 'Abogados',
    route: ROUTES.ADMIN_LAWYER,
    whiteImage: profileWhiteImg,
    blueImage: profileBlueImg,
  },
  {
    name: 'Despachos',
    route: ROUTES.ADMIN_LAWYER_FIRM,
    whiteImage: portfolioWhite,
    blueImage: portfolioBlue,
  },
  {
    name: 'Cliente/Usuarios',
    route: ROUTES.ADMIN_CLIENT,
    whiteImage:  usersWhite,
    blueImage: usersBlue,
  },
  {
    name: 'Contact center',
    route: ROUTES.ADMIN_CONTACT_CENTER,
    whiteImage: contactWhite,
    blueImage: contactBlue,
  },
  {
    name: 'Artículos',
    route: ROUTES.DASHBOARD_ADMIN,
    whiteImage: articleWhite,
    blueImage: articleBlue,
  },
  {
    name: 'Cuenta',
    route: ROUTES.DASHBOARD_ADMIN,
    whiteImage: accountWhiteImg,
    blueImage: accountBlueImg,
  },
  {
    name: 'Papelera',
    route: ROUTES.DASHBOARD_ADMIN,
    whiteImage: trashWhite,
    blueImage: trashBlue,
  },
  { isDivider: true },
  {
    name: 'Cerrar sesión',
    route: ROUTES.DASHBOARD_ADMIN,
    whiteImage: signOutWhiteImg,
    blueImage: signOutBlueImg,
  },
];

const useStyles = makeStyles({
  containerMenu: props => ({
    backgroundColor: props.isMobile ? '#ffffff' : 'transparent',
  }),
  navList: {
    borderRadius: props => (props.isMobile ? 0 : 5),
    backgroundColor: '#ffffff',
    paddingTop: 0
  },
  linkItem: {
    color: 'inherit',
    textDecoration: 'none',
  },
  linkItemDisabled: {
    color: 'inherit',
    textDecoration: 'none',
    cursor: 'not-allowed'
  },
  listItemButton: {
    borderRadius: 5,
    color: '#013957',
    border: 'none',
    backgroundColor: '#ffffff',
  },
  listItemSelected: {
    backgroundColor: '#35b9b6 !important',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#1daeab !important',
    },
  },
  primaryListItemText: {
    fontWeight: 'bold',
  },
  spaceDivider: {
    height: props => (props.isMobile ? '3vh' : '7vh'),
    //borderBottom: '1px solid rgba(53, 185, 182, 0.3)',
  },
  userButton: {
    borderBottom: '1px solid rgba(53, 185, 182, 0.3)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  switcherContainer: {
    display: 'flex',
  }
});

const SideMenuNavList = props => {
  const classes = useStyles(props);
  const tablet = useMediaQuery('(max-width: 768px)');

  const paymentRoute = useRouteMatch(ROUTES.MEMBERSHIP_PAYMETHOD);
  const historyRoute = useRouteMatch(ROUTES.MEMBERSHIP_HISTORY);
  const invoicesRoute = useRouteMatch(ROUTES.MEMBERSHIP_INVOICES);
  const location = useLocation();

  const {
    expandDrawer,
    isMobile,
    handleToggleDrawer,
    logoutUser,
    adminMenu,
    authClient,
    notifications,
    makeOpenModal,
    showLoading,
    hideLoading,
    loginUser,
    credentialsLawyer,
    idLawFirm,
    membership,
    changeToCourtesyLawyer,
    // isExpandedSideMenu,
    // handleOpenSideMenu,
    // openDrawer,
    // handleOpenMenu,
    // hadleSideMenu,
    // profile,
  } = props;

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [ openModal, setOpenModal ] = useState(false);

  useEffect(() => {
    if(historyRoute || paymentRoute || invoicesRoute){
      setSelectedIndex(3);
    }
    
  }, [historyRoute, paymentRoute, invoicesRoute, membership ]);

  const handleListItemClick = (event, index, name) => {
    
    if (name === 'Cerrar sesión') {
      event.preventDefault()
      if (isMobile === true) {
        makeOpenModal()
      } else {
        handleOpenModal()
      }
    }
    setSelectedIndex(index);
    handleToggleDrawer && handleToggleDrawer(event);
  };

  let dashboardOptions = [...lawyerOptions];
  if (membership && membership.type && membership.type === 'Freemium' ) {
    dashboardOptions = lawyerOptions.filter(item => item.name !== 'Propuesta económica')
  }
  const menuOptions = adminMenu ? adminOptions : dashboardOptions;

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const makeSelected = (index, match) =>{
    if (match && match.isExact) {
      setSelectedIndex(index);                
      return true;
    } else {
      return false;
    }
  }

  const [ displayDropdown, setDisplayDropdown ] = useState(false)
  const [ selectedElemInDrop, setSelectedElemInDrop ] = useState(authClient && authClient.role === 'lawFirm' ? 1 : 0);
  const [ formikModal, setFormikModal ] = useState(false);

  const handleChangeDropdown = () => {
    if (
      idLawFirm ||
      (credentialsLawyer &&
      credentialsLawyer.email &&
      credentialsLawyer.password)
    ) {
      setDisplayDropdown(!displayDropdown)
    }
  }

  const handleSelectItem = async (event, index) => {
    if (index === 0 && selectedElemInDrop !== 0) {
      try {
        showLoading()
        const data = await decryptPassword({
          email: credentialsLawyer.email,
          password: credentialsLawyer.password
        })
        const { email, password } = data
        await logoutUser()
        // ESTA FUNCIÓN SE LLAMA EN VEZ DEL LOGIN PORQUE EL ABOGADO
        // QUE LE PERTENECE A UN DESPACHO NO PUEDE HACER LOGIN DIRECTO EN EL PORTAL
        const userResponse = await doSignInWithEmailAndPassword(email, password)
        changeToCourtesyLawyer(userResponse)
        hideLoading()
      } catch (error) {
        hideLoading()
        console.log('error', error);
      }
    } else if (index === 1 && selectedElemInDrop !== 1) {
      setSelectedElemInDrop(index);
      handleChangeFormikModal()
    }
  }

  const handleChangeFormikModal = () => {
    setFormikModal(!formikModal)
  }

  const changeToLawfirm = async (values) => {
    try {
      showLoading()
      await logoutUser()
      await loginUser(values.email, values.password, 'lawyeruser')
      hideLoading()
    } catch (error) {
      hideLoading()
      console.log('error', error);
    }
  }

  return (
    <>
      <Popup
        open={openModal}
        handleClose={handleCloseModal}
        title='¿Quieres salir de tu sesión?'
        subtitle='Tendrás que volver a iniciar sesión para ingresar.'
        primaryButton={true}
        primaryButtonVariant='primarySolidOutlined'
        primaryButtonText='Sí, salir'
        primaryFunction={logoutUser}
        secondaryButton={true}
        secondaryButtonVariant='primary'
      />

      <SwitcherModal
        open={formikModal} 
        handleClose={handleChangeFormikModal}
        primaryFunction={changeToLawfirm}
        setSelectedElemInDrop={setSelectedElemInDrop}
      />
      
      <div className={classes.containerMenu}>
        <List component="nav" className={classes.navList}>
          {tablet &&
            <ListItem className={classes.userButton}>
                <div className={classes.switcherContainer}>
                  <Session
                    profile={authClient}
                    inDrawer
                    blueName
                  />
                  {idLawFirm ||
                  (credentialsLawyer &&
                  credentialsLawyer.email &&
                  credentialsLawyer.password) ?
                    (displayDropdown ?
                      <img
                        src='/img/switcher-login/drop-up.svg'
                        onClick={handleChangeDropdown}
                        alt='arrow'
                      /> :
                      <img
                        src='/img/switcher-login/drop-down.svg'
                        onClick={handleChangeDropdown}
                        alt='arrow'
                      />
                    ) : null
                  }
                </div>
                {displayDropdown ?
                  <SwitcherList
                    selectedIndex={selectedElemInDrop}
                    handleListItemClick={handleSelectItem}
                  /> : null
                }
            </ListItem>
          }

          {menuOptions.map(
            ({ name, whiteImage, blueImage, route, isDivider }, index) => {
              if (!isDivider) {
                return (
                  <NavLink
                    key={index}
                    to={
                      membership &&
                      membership.type &&
                      membership.type === 'Freemium' &&
                      location &&
                      name === 'Propuesta económica' ?
                      location.pathname : route
                    }
                    isActive={(match, location) => {
                      makeSelected(index ,match, location);
                    }}
                    className={
                      membership &&
                      membership.type &&
                      membership.type === 'Freemium' &&
                      name === 'Propuesta económica' ?
                      classes.linkItemDisabled :
                      classes.linkItem
                    }
                  >
                    <ListItem
                      selected={selectedIndex === index}
                      onClick={event => handleListItemClick(event, index, name)}
                      classes={{
                        button: classes.listItemButton,
                        selected: classes.listItemSelected,
                      }}
                      disabled={
                        membership &&
                        membership.type &&
                        membership.type === 'Freemium' &&
                        name === 'Propuesta económica' ?
                        true : false
                      }
                      style={{ height: 48 }}
                      button
                    >
                      {expandDrawer ? (
                        <>
                          <ListItemIcon>
                            {isMobile && name === 'Notificaciones'? (
                                <Badge
                                  badgeContent={
                                    notifications &&
                                    notifications.filter((n) => !n.read).length
                                  }
                                  max={99}
                                  color="error"
                                  anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                  }}
                                >
                                  <img
                                    src={selectedIndex !== index ? blueImage : whiteImage}
                                    alt="side-menu-option"
                                  />
                                </Badge>
                              ) :
                              (
                                <img
                                  src={selectedIndex !== index ? blueImage : whiteImage}
                                  alt="side-menu-option"
                                />
                              )
                            }
                            
                          </ListItemIcon>
                          <ListItemText
                            primary={name}
                            classes={{ primary: classes.primaryListItemText }}
                          />
                        </>
                      ) : (
                        <Tooltip title={name} placement="right">
                          <img
                            src={selectedIndex !== index ? blueImage : whiteImage}
                            alt="side-menu-option"
                          />
                        </Tooltip>
                      )}
                    </ListItem>
                  </NavLink>
                );
              } else {
                return <div key={index} className={classes.spaceDivider}></div>;
              }
            }
          )}
        </List>
      </div>
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  loginUser: (email, password, roleAuth) => dispatch(loginUser(email, password, roleAuth)),
  changeToCourtesyLawyer: userResponse => dispatch(changeToCourtesyLawyer(userResponse)),
  logoutUser: () => dispatch(logoutUser()),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
}); 

const mapStateToProps = state => ({
  notifications: state.authClient.notificationsLaw,
  authClient: state.authClient,
  credentialsLawyer: state.authClient.credentialsLawyer,
  imgProfile: state.authClient.imgProfile,
  membership: state.authClient.membership,
  idLawFirm: state.authClient.idLawFirm,
});

export default connect(mapStateToProps, mapDispatchToProps)(SideMenuNavList);